import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import reducer from './reducer';
import saga from './saga';
import * as mapDispatch from './action';
import { State, mapStateToProps } from './selector';
import { CaptchaMediaType, FormStatus } from './enum';
import { mountLoadingSpinner } from '../../components/LoadingSpinner';
import { mountLmsForm } from './helpers/mountLmsForm.helper';
import { createCaptcha } from './helpers/createCaptcha.helper';
import { mountResultNotification } from '../../components/Notification';
import { showResults } from './helpers/notification.helper';
import { trackPageView } from './tracking';
import { reinitFootnotes } from '../../components/Footnote';
import { Namespace } from '../../enum';
import { AppId } from '../../enums/elementId';
import { loadInitialAppState } from './helpers/state.helper';
import { updateAddressInputs } from './helpers/form.helper';
import { getUpdateFlags } from './update';

function lmsFormContainer(_: State, actions: typeof mapDispatch) {
    injectReducer(Namespace.APP, reducer);
    injectSaga(Namespace.APP, saga);

    const loadingSpinner = mountLoadingSpinner();
    const formElements = mountLmsForm(actions);
    const resultNotification = mountResultNotification();
    const formContainer = document.getElementById(AppId.ID_WRAPPER_LMS_FORM);

    reinitFootnotes();

    actions.initStore(loadInitialAppState());
    actions.getCaptcha(CaptchaMediaType.HEADER_IMAGE);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);

            // toggle loading spinner
            if (update.loading && loadingSpinner) {
                loadingSpinner.toggle();
            }

            if (update.address && newState.address) {
                updateAddressInputs(formElements.formToValidate.formFields, newState.address);
            }

            // handle captcha error
            if (update.captchaError && resultNotification) {
                showResults(formContainer, resultNotification, false, actions);
                trackPageView(FormStatus.FAILURE, newState.captcha?.error);
                return;
            }

            // generate captcha
            if (update.captcha) {
                const { validatorUrl, captchaMediaType } = newState.captcha || {};

                createCaptcha(captchaMediaType, validatorUrl || '', actions, formElements);
                trackPageView(FormStatus.START);
            }

            // show success notification
            if (update.response) {
                showResults(formContainer, resultNotification, true);
                trackPageView(FormStatus.SUCCESS);
            }

            // show error notification
            if (update.error) {
                showResults(formContainer, resultNotification, false, actions, newState.error);
                trackPageView(FormStatus.FAILURE, newState.error);
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(lmsFormContainer);
